import request from '@/utils/http';
// 新增叉车
export const saveForkTruckInfo = (params) => {
    return request({
        url: `/api-srm-web/supplier/supplierForkliftInfo/addForkliftInfo`,
        method: 'post',
        data: params
    });
};
// 编辑
export const editForkTruckInfo = (params) => {
    return request({
        url: `/api-srm-web/supplier/supplierForkliftInfo/updateForkliftInfo`,
        method: 'post',
        data: params
    });
};
// 删除叉车
export const deleteForkTruckInfo = (params) => {
    return request({
        url: `/api-srm-web/supplier/supplierForkliftInfo/delete`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
// 刷新
export const getForkTruckInfo = (params) => {
    return request({
        url: `/api-srm-web/supplier/searchsupplierForkliftInfos`,
        method: 'post',
        data: params
    });
};
// 启用
export const startForkTruckInfo = (params) => {
    return request({
        url: `/api-srm-web/supplier/supplierForkliftInfo/batchEnable`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
// 停用
export const stopForkTruckInfo = (params) => {
    return request({
        url: `/api-srm-web/supplier/supplierForkliftInfo/batchDisEnable`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
// 查询详情
export const getForkTruckInfoDetail = (params) => {
    return request({
        url: `/api-srm-web/supplier/getSupplierForkliftInfo/${params}`,
        method: 'get',
        data: params
    });
};
// 导出叉车列表
export const exportForkTruckList = (params) => {
    return request({
        url: `/api-srm-web/supplier/supplierForkliftInfo/exportForkliftInfoList`,
        method: 'post',
        data: params,
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'application/json'
        }
    });
};